import React, { useEffect, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  getRequiredOrientation,
  isTabletDevice,
  shouldShowOrientationOverlay,
} from "../../utils/orientationLock";

const useStyles = makeStyles({
  overlayBase: {
    position: "fixed",
    inset: 0,
    zIndex: 9999,
    backgroundColor: "rgba(0, 0, 0, 0.92)",
    color: "#ffffff",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "32px",
    boxSizing: "border-box",
  },
  icon: {
    fontSize: "64px",
    marginBottom: "16px",
    display: "block",
    lineHeight: 1,
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "15px",
    opacity: 0.75,
    margin: 0,
  },
});

export default function OrientationLockOverlay() {
  const classes = useStyles();
  const [visible, setVisible] = useState(() => shouldShowOrientationOverlay(window));
  const requiredOrientation = useMemo(() => getRequiredOrientation(window), []);
  const tabletDevice = useMemo(() => isTabletDevice(window), []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const syncVisibility = () => {
      setVisible(shouldShowOrientationOverlay(window));
    };

    syncVisibility();

    const mediaQuery =
      typeof window.matchMedia === "function"
        ? window.matchMedia("(display-mode: standalone)")
        : null;

    window.addEventListener("resize", syncVisibility);
    window.addEventListener("orientationchange", syncVisibility);
    if (
      window.visualViewport &&
      typeof window.visualViewport.addEventListener === "function"
    ) {
      window.visualViewport.addEventListener("resize", syncVisibility);
    }
    if (
      window.screen &&
      window.screen.orientation &&
      typeof window.screen.orientation.addEventListener === "function"
    ) {
      window.screen.orientation.addEventListener("change", syncVisibility);
    }
    if (mediaQuery && typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", syncVisibility);
    }

    return () => {
      window.removeEventListener("resize", syncVisibility);
      window.removeEventListener("orientationchange", syncVisibility);
      if (
        window.visualViewport &&
        typeof window.visualViewport.removeEventListener === "function"
      ) {
        window.visualViewport.removeEventListener("resize", syncVisibility);
      }
      if (
        window.screen &&
        window.screen.orientation &&
        typeof window.screen.orientation.removeEventListener === "function"
      ) {
        window.screen.orientation.removeEventListener("change", syncVisibility);
      }
      if (mediaQuery && typeof mediaQuery.removeEventListener === "function") {
        mediaQuery.removeEventListener("change", syncVisibility);
      }
    };
  }, []);

  if (!visible || !requiredOrientation) {
    return null;
  }

  return (
    <div className={classes.overlayBase} style={{ display: "flex" }}>
      <span className={classes.icon}>{tabletDevice ? "↻" : "↺"}</span>
      <p className={classes.title}>Gire o dispositivo</p>
      <p className={classes.subtitle}>
        {tabletDevice
          ? "Por favor, use o tablet na posição horizontal (paisagem)."
          : "Por favor, use o celular na posição vertical (retrato)."}
      </p>
    </div>
  );
}
